'use strict';

var carousels = require('../components/carousels');
var utils = require('../util/utils');
var imagesloaded = require('imagesloaded');

/**
 * Init Asset Modal
 *
 */
function initAssetModal() {
    $('.js-subscribe-details').off().on('click', function () {
        var $modal = $('#recommendationInterceptModal');
        var $modalAsset = $('#assetSubscribeDetails');

        $modal.modal('hide');
        $modalAsset.modal('show');
    });
}

/**
 * Parses the html for a modal window
 * @param {string} html - representing the body and footer of the modal window
 * @return {Object} - Object with properties body and footer.
 */
function parseHtml(html) {
    var $html = $('<div>').append($.parseHTML(html));
    var modal = {};
    var modalAsset = {};

    modal.body = $html.find('.recommendation-intercept-products');
    modal.header = $html.find('.recommendation-intercept-products-header').children();
    modal.footer = $html.find('.recommendation-intercept-footer').children();

    modalAsset.body = $html.find('.assetSubscribeDetails-body');
    modalAsset.header = $html.find('.assetSubscribeDetails-header').children();
    modalAsset.footer = $html.find('.assetSubscribeDetails-footer').children();

    return {
        modal: modal,
        modalAsset: modalAsset
    };
}

/**
 * Renders a modal window that will show recommendations
 * for either a product (PDP) or the entire basket (Cart)
 * @param {Object} data - data object used to fill in dynamic portions of the html
 * @returns {Object} a promise
 */
function showRecommendationIntercept(data) {
    var defer = $.Deferred(); // eslint-disable-line

    if (!data || !data.url) {
        defer.reject();
    }

    var action = $('.page').data('action');
    // do not show recommendation intercept on cart page. it is handled through showCartIntercept()
    if (action && action === 'Cart-Show') {
        defer.reject({
            redirectUrl: utils.appendParamToURL(location.href, 'showIntercept', false)
        });
    }

    if ($('#recommendationInterceptModal').length !== 0) {
        $('#recommendationInterceptModal').remove();
    }

    var htmlString = '<!-- Modal -->'
        + '<div class="modal fade" id="recommendationInterceptModal" tabindex="-1" role="dialog" aria-label="You may also like">'
        + '<div class="modal-dialog recommendation-intercept-dialog modal-lg">'
        + '<!-- Modal content-->'
        + '<div class="modal-content">'
        + '<div class="modal-footer"></div>'
        + '<div class="modal-header"></div>'
        + '<div class="modal-body"></div>'
        + '</div>'
        + '</div>'
        + '</div>';

    var htmlAssetString = '<!-- Modal -->'
        + '<div class="modal fade" id="assetSubscribeDetails" tabindex="-1" role="dialog" aria-label="Subscribe & Save">'
        + '<div class="modal-dialog">'
        + '<!-- Modal content-->'
        + '<div class="modal-content">'
        + '<div class="modal-header"></div>'
        + '<div class="modal-body"></div>'
        + '<div class="modal-footer"></div>'
        + '</div>'
        + '</div>'
        + '</div>';

    $('body').append(htmlString);
    $('body').append(htmlAssetString);

    $.spinner().start();
    $.ajax({
        type: 'GET',
        url: data.url,
        dataType: 'html'
    }).done(function (content, textStatus, request) {
        var response = request.getResponseHeader('Content-Type');
        if (/json/.test(response)) {
            response = jQuery.parseJSON(content);
            if (response && response.error) {
                defer.reject();
            }
        } else {
            var $modal = $('#recommendationInterceptModal');
            var $modalAsset = $('#assetSubscribeDetails');
            var parsedHtml = parseHtml(content);

            $modal.find('.modal-header').html(parsedHtml.modal.header);
            $modal.find('.modal-body').html(parsedHtml.modal.body);
            $modal.find('.modal-footer').html(parsedHtml.modal.footer);

            $modalAsset.find('.modal-header').html(parsedHtml.modalAsset.header);
            $modalAsset.find('.modal-body').html(parsedHtml.modalAsset.body);
            $modalAsset.find('.modal-footer').html(parsedHtml.modalAsset.footer);

            $modal.modal({ show: false });
            $modal.on('shown.bs.modal', function () {
                initAssetModal();
                imagesloaded(this).on('always', carousels.productTileInterceptCarousels);
            });
            $modal.modal('show');

            defer.resolve();
        }
        $.spinner().stop();
    }).fail(function () {
        defer.reject();
        $.spinner().stop();
    });

    return defer;
}

/**
 * Determines if an intercept modal should show on the cart page
 */
function showCartIntercept() {
    var cartIntercept = $('.cart-recommendation-intercept');
    var qsShowIntercept = utils.getQueryStringParams(location).showIntercept;

    if (cartIntercept.length && cartIntercept.data('enabled') === true && cartIntercept.data('url') !== null && qsShowIntercept !== 'false') {
        showRecommendationIntercept({ url: cartIntercept.data('url') });
    }
}

module.exports = {
    methods: {
        showRecommendationIntercept: showRecommendationIntercept,
        showCartIntercept: showCartIntercept
    }
};
